/**
 * Coordonnées de l'entreprise — SOURCE UNIQUE de tout balisage structuré (JSON-LD).
 *
 * POURQUOI CE FICHIER. Au 03/11/2026, l'adresse était recopiée à la main dans 7 blocs
 * JSON-LD (EnhancedStructuredData, StructuredData, EventStructuredData, OfferProductPage,
 * Index, seoEventSync, index.html), et la page Mentions légales en portait une 8e. Les
 * copies avaient divergé exactement comme le prévoit la règle n°1 du CLAUDE.md : les pages
 * légales disaient « 93210 Saint-Denis », le balisage « Paris 75000 » — un code postal qui
 * n'existe pas — avec les coordonnées de Notre-Dame, à 6,5 km. L'extrait Google de Mappy,
 * lui, affichait 93200 (PagesJaunes, vérifié, est bien en 93210). Les moteurs et les IA
 * identifient une entreprise en recoupant ces sources ; elles se contredisaient.
 *
 * Adresse confirmée par l'entreprise le 03/11/2026, et par la Base Adresse Nationale
 * (api-adresse.data.gouv.fr) : « 4 Rue du Capitaine Alfred Dreyfus 93210 Saint-Denis »,
 * précision au numéro, score 0,97. C'est La Plaine Saint-Denis, d'où 93210 et non 93200.
 *
 * index.html ne peut pas importer ce fichier (c'est le gabarit HTML) : il en porte une
 * copie, vérifiée par `node scripts/verifier-coordonnees.mjs`, comme les pages légales.
 * Toute modification se fait ICI, puis ce script dit ce qu'il reste à aligner.
 */

export const ADRESSE_ENTREPRISE = {
  '@type': 'PostalAddress',
  streetAddress: '4 rue du capitaine Alfred Dreyfus',
  postalCode: '93210',
  addressLocality: 'Saint-Denis',
  addressRegion: 'Île-de-France',
  addressCountry: 'FR',
} as const;

/** Coordonnées de la Base Adresse Nationale pour l'adresse ci-dessus. */
export const GEO_ENTREPRISE = {
  '@type': 'GeoCoordinates',
  latitude: 48.914902,
  longitude: 2.354758,
} as const;

/**
 * Profils tiers déclarés en `sameAs`. N'y figurent QUE des URLs vérifiées en ligne le
 * 03/11/2026 : une URL fausse en `sameAs` fait plus de tort qu'une URL absente.
 *
 * - Instagram, Pinterest : page ouverte, nom de l'entreprise affiché.
 * - Sortlist : « Maison Eridia, Saint-Denis ».
 * - Mariages.net : adresse canonique donnée par la page elle-même (identifiant 407081,
 *   celui du badge partenaire affiché sur le site).
 * - PagesJaunes : fiche vérifiée (badge bleu), canonique /pros/64595640, adresse
 *   « 4 rue Capit Alfred Dreyfus, la Plaine St Denis 93210 Saint Denis ». Les « 93200 »
 *   présents sur la page appartiennent au bloc « ces pros peuvent aussi vous
 *   intéresser » (d'autres entreprises), pas à la fiche.
 * - LinkedIn : NON vérifiable — mur de connexion. Une page entreprise à ~350 abonnés
 *   existe ; ce slug était déjà déclaré, il est conservé faute de preuve contraire.
 *
 * Volontairement ABSENTS :
 * - Facebook : https://www.facebook.com/maisoneridia répond « Ce contenu n'est pas
 *   disponible ». La vraie page a une autre adresse, à fournir avant de l'ajouter.
 * - Mappy : son extrait dans Google affichait 93200 le 03/11/2026. Mappy appartient au
 *   même groupe que PagesJaunes et en reprend souvent les fiches ; à ajouter une fois
 *   son adresse vérifiée en 93210.
 */
export const PROFILS_ENTREPRISE = [
  'https://www.instagram.com/maisoneridia/',
  'https://fr.pinterest.com/maisoneridia/',
  'https://www.linkedin.com/company/maisoneridia',
  'https://www.sortlist.fr/agency/maison-eridia',
  'https://www.mariages.net/organisation-mariage/maison-eridia--e407081',
  'https://www.pagesjaunes.fr/pros/64595640',
] as const;
